// One file per namespace: "common" for shared texts, the rest per area
import common from "./common.json";
import activeDirectory from "./activeDirectory.json";
import auth from "./auth.json";
import buildings from "./buildings.json";
import campus from "./campus.json";
import districts from "./districts.json";
import domain from "./domain.json";
import form from "./form.json";
import incidents from "./incidents.json";
import internalAdmin from "./internalAdmin.json";
import internalPolicies from "./internalPolicies.json";
import internalTags from "./internalTags.json";
import layout from "./layout.json";
import lockdownStage from "./lockdownStage.json";
import ongoingIncidents from "./ongoingIncidents.json";
import profileSetting from "./profileSetting.json";

const en = {
  common,
  activeDirectory,
  auth,
  buildings,
  campus,
  districts,
  domain,
  form,
  incidents,
  internalAdmin,
  internalPolicies,
  internalTags,
  layout,
  lockdownStage,
  ongoingIncidents,
  profileSetting,
};

export default en;
